import { useTranslations } from "use-intl";
import clsx from "clsx";
import type { FindPackageByIdCountry } from "@/app/lib/types/codegen";
import { CollapsibleCard } from "../../CollapsibleCard";

type Props = {
  countries: FindPackageByIdCountry[];
};

export function VisaPermissionsCard({ countries }: Props) {
  const t = useTranslations();

  return (
    <CollapsibleCard
      title={t("trips.visaPermissions.title")}
      subtitle={t("trips.visaPermissions.subtitle")}
      collapsible={false}
    >
      <ul className="space-y-2">
        {countries?.map(({ id, name, visaType }) => {
          const getVisaTranslation = () => {
            switch (visaType) {
              case "E_VISA":
                return t("trips.visaTypes.eVisa");
              case "VISA_ON_ARRIVAL":
                return t("trips.visaTypes.visaOnArrival");
              case "VISA_FREE":
                return t("trips.visaTypes.visaFree");
              case "VISA_REQUIRED":
                return t("trips.visaTypes.visaRequired");
              default:
                return visaType; // Fallback to raw value if no translation is found
            }
          };

          return (
            <li
              key={id}
              className={clsx(
                "flex items-center justify-between rounded-xl p-3 text-sm font-medium text-text-primary",
                visaType === "VISA_FREE"
                  ? "bg-surface-accent-softer"
                  : visaType === "VISA_REQUIRED"
                    ? "bg-semantic-error-pressed-soft"
                    : "bg-semantic-warning-soft",
              )}
            >
              <span>{name}</span>
              <span>{getVisaTranslation()}</span>
            </li>
          );
        })}
      </ul>
    </CollapsibleCard>
  );
}
